export default { TwoKeyCPCCampaign:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'moderatorTotalEarnings',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getRebalancingStatus',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'publicMetaHash',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'logicHandler',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newPublicMetaHash', type: 'string' } ],
          name: 'updateIpfsHashOfCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getReservedAmountForRewards',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAvailableInventory',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'totalSupply',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'bountyPerConversion',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'isInventoryAdded',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'influencers', type: 'address[]' },
             { name: 'balances', type: 'uint256[]' } ],
          name: 'pushAndDistributeRewardsBetweenInfluencers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'moderator',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'privateMetaHash',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'totalAmountForRewards', type: 'uint256' } ],
          name: 'lockContractReserveTokensAndRebalanceRates',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'isValidated',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'targetUrl',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_receiver', type: 'address' } ],
          name: 'getReceivedFrom',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'totalEarnings', type: 'uint256' } ],
          name: 'setAndDistributeModeratorEarnings',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'contractorWithdrawnLeftOverTokens',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'me', type: 'address' } ],
          name: 'publicLinkKeyOf',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'initialInventoryAmount',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'addDirectly2KEYAsInventory',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_owner', type: 'address' } ],
          name: 'balanceOf',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getConstantInfo',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractorBalanceAndTotalProceeds',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_influencer', type: 'address' } ],
          name: 'getReferrerPlasmaBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'conversionHandler',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'usd2KEYrateWei',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'moderatorFee', type: 'uint256' } ],
          name: 'buyTokensForModeratorRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'moderatorTokens', type: 'uint256' } ],
          name: 'updateModeratorRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_referrerPlasma', type: 'address' } ],
          name: 'getReferrerTotalRewardsAndCurrentBalance',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'validateContractFromMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'leftOverTokensForContractor',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getInventoryStatus',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_cancelledConverter', type: 'address' },
             { name: '_conversionAmount', type: 'uint256' } ],
          name: 'sendBackEthWhenConversionCancelledOrRejected',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_user', type: 'address' } ],
          name: 'getNumberOfUsersToContractor',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_publicMetaHash', type: 'string' },
             { name: '_privateMetaHash', type: 'string' },
             { name: '_publicKey', type: 'address' } ],
          name: 'startCampaignWithInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'buyReferralBudgetWithEth',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_influencer', type: 'address' },
             { name: '_balance', type: 'uint256' } ],
          name: 'updateReferrerPlasmaBalance',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'boughtRewardsWithEther',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'mirrorCampaignOnPlasma',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'isContractLocked',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'withdrawRemainingRewardsInventory',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'me', type: 'address' } ],
          name: 'getReferrerCut',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'totalRewardsDistributed',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'contractor',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_contractor', type: 'address' },
             { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_url', type: 'string' },
             { name: '_mirrorCampaignOnPlasma', type: 'address' },
             { name: '_bountyPerConversion', type: 'uint256' },
             { name: '_twoKeyEconomy', type: 'address' } ],
          name: 'setInitialParamsCPCCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyCPCCampaign' },
  TwoKeyCPCCampaignPlasma:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'moderatorTotalEarnings',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'publicMetaHash',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newPublicMetaHash', type: 'string' } ],
          name: 'updateIpfsHashOfCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'totalSupply',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'moderator',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'privateMetaHash',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'isValidated',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'targetUrl',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAvailableBounty',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_receiver', type: 'address' } ],
          name: 'getReceivedFrom',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'lockContractFromMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'me', type: 'address' } ],
          name: 'publicLinkKeyOf',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'contractorPublicAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getCounters',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'updateContractorWithdrawnBounty',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_owner', type: 'address' } ],
          name: 'balanceOf',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_influencer', type: 'address' } ],
          name: 'getReferrerPlasmaBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'ratio', type: 'uint256' } ],
          name: 'adjustRebalancingResultsAndSetRatio',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'mirrorCampaignOnPublic',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfActiveInfluencers',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getBountyAndClicksStats',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_mirrorCampaign', type: 'address' } ],
          name: 'setMirrorCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'address' } ],
          name: 'converterToConversionId',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'validateContractFromMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_referrerPlasmaList', type: 'address[]' } ],
          name: 'getReferrersBalancesAndTotalEarnings',
          outputs:
           [ { name: '', type: 'uint256[]' },
             { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'getSuperStatistics',
          outputs:
           [ { name: '', type: 'bool' },
             { name: '', type: 'bool' },
             { name: '', type: 'bool' },
             { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_user', type: 'address' } ],
          name: 'getNumberOfUsersToContractor',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'rebalancingRatio',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_referrerAddress', type: 'address' },
             { name: '_sig', type: 'bytes' },
             { name: '_conversionIds', type: 'uint256[]' } ],
          name: 'getReferrerBalanceAndTotalEarningsAndNumberOfConversions',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256[]' },
             { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_publicMetaHash', type: 'string' },
             { name: '_privateMetaHash', type: 'string' },
             { name: '_publicKey', type: 'address' } ],
          name: 'startCampaignWithInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'start', type: 'uint256' },
             { name: 'end', type: 'uint256' } ],
          name: 'getInfluencersAndBalances',
          outputs:
           [ { name: '', type: 'address[]' },
             { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_totalBounty', type: 'uint256' } ],
          name: 'setTotalBounty',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'customer', type: 'address' } ],
          name: 'getReferrers',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getActiveInfluencers',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'isContractLocked',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getAddressJoinedStatus',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'contractor',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'converter', type: 'address' } ],
          name: 'isConverter',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'conversionId', type: 'uint256' } ],
          name: 'ConversionCreated',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_contractor', type: 'address' },
             { name: '_moderator', type: 'address' },
             { name: '_url', type: 'string' },
             { name: 'numberValues', type: 'uint256[]' } ],
          name: 'setInitialParamsCPCCampaignPlasma',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'signature', type: 'bytes' } ],
          name: 'convert',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'converter', type: 'address' } ],
          name: 'approveConverterAndExecuteConversion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'converter', type: 'address' },
             { name: 'rejectionStatusCode', type: 'uint256' } ],
          name: 'rejectConverterAndConversion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_conversionId', type: 'uint256' } ],
          name: 'getConversion',
          outputs:
           [ { name: '', type: 'address' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint8' },
             { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyCPCCampaignPlasma' },
  NonSingletonsHash:
   '95a6454e154c99a874bbba5c0b867a38c7a967fb90b7dc59087cfbe18beb87aa',
  SingletonsHash:
   'f182a0f2a82b0d258eaa16e1ff0e6bbcc2cd2f45247e2e7bb145fa59cbe3f803' }